'use client'

import Link from 'next/link'
import Image from 'next/image'

export function ModernHero() {
  return (
    <section className="relative w-full h-[85vh] md:h-screen overflow-hidden bg-[#1a1a2e]">
      {/* Background Image */}
      <Image
        src="/images/hero-modern.jpg"
        alt="Aussie Style Collection"
        fill
        className="object-cover opacity-70"
        priority
      />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
      
      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <p className="text-white/80 text-xs md:text-sm tracking-[0.3em] uppercase mb-4 font-light">
          Oriental Fashion Collection
        </p>
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 tracking-tight leading-tight">
          New Season
          <br />
          <span className="text-[#C8A860]">Arrivals</span>
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-md mb-10 font-light leading-relaxed">
          Discover our curated collection of oriental fashion — scarves, jewellery, jackets and more.
        </p>
        
        {/* CTAs */}
        <div className="flex gap-4">
          <Link
            href="/store"
            className="bg-white text-black px-8 py-3.5 text-xs font-semibold tracking-[0.2em] uppercase hover:bg-[#C8A860] hover:text-white transition-all duration-300"
          >
            Shop Women
          </Link>
          <Link
            href="/store"
            className="border border-white/60 text-white px-8 py-3.5 text-xs font-semibold tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-300"
          >
            Shop All
          </Link>
        </div>
      </div>

      {/* Free shipping banner */}
      <div className="absolute bottom-0 left-0 right-0 bg-[#C8A860] text-black text-center py-2.5 text-xs tracking-[0.15em] font-medium">
        FREE SHIPPING ON ALL ORDERS OVER $80 AUD
      </div>
    </section>
  )
}
